module.exports = __webpack_public_path__ + "media/images/emblems/Kandergrund-coat_of_arms-665f67039f81d90e2db4298362578779.svg";